import "./About.css";
const About = () => (
	<div className="about">
		<h1>About</h1>
	</div>
);
export default About;
